import src from "IMAGE";
export default { src, width: 780, height: 1000, blurWidth: 0, blurHeight: 0};
